import React from "react"
import { styled, Theme, CSSObject } from "@mui/material/styles"

import MuiDrawer from "@mui/material/Drawer"
import { useResponsive } from "src/utils/useResponsive"

const drawerWidth = 250
const mobileDrawerWidth = "100%"

const openedMixin = (theme: Theme, isMobile: boolean): CSSObject => ({
  overflowX: "hidden",
  justifyContent: "space-between",
  width: isMobile ? mobileDrawerWidth : drawerWidth,
  transition: theme.transitions.create(isMobile ? "transform" : "width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  })
})

const closedMixin = (theme: Theme, isMobile: boolean): CSSObject => ({
  overflowX: "hidden",
  justifyContent: "space-between",
  transition: theme.transitions.create(isMobile ? "transform" : "width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  width: isMobile ? mobileDrawerWidth : `calc(${theme.spacing(4)} + 20px)`
})

export const NavbarDrawer = styled(MuiDrawer)(({ theme }) => {
  const { isMobile } = useResponsive()

  return {
    overflowX: "hidden",
    width: isMobile ? mobileDrawerWidth : drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    variants: [
      {
        props: (props: any) => props.open,
        style: {
          ...openedMixin(theme, isMobile),
          "& .MuiDrawer-paper": openedMixin(theme, isMobile)
        }
      },
      {
        props: (props: any) => !props.open,
        style: {
          ...closedMixin(theme, isMobile),
          "& .MuiDrawer-paper": closedMixin(theme, isMobile)
        }
      }
    ]
  }
})
